import { combineReducers } from "redux";
import basicConfigReducer from "./basicconfig/basicConfigReducer";
import mapperReducer from "./mapper/mapper";
import loaderReducer from "./loader/loaderReducer";

const rootReducer = combineReducers({
  mapperReducer: mapperReducer,
  basicConfigReducer: basicConfigReducer,
  loaderReducer: loaderReducer,
  // Add other reducers here
});

export default rootReducer;
